import React, { useReducer } from 'react';
import ServiceProfileContext from './serviceProfileContext';
import serviceProfileReducer from './ServiceProfileReducer';

import clienteAxios from '../../service/axios';

import {
    OBTENER_SERVICE_PROFILES,
    OBTENER_SERVICE_PROFILE,
    MARCA_ERROR,
    MARCA_OK
} from 'types/context';
import { MENSAJE_ALERTA_TYPE } from 'types/MENSAJE_ALERTA_TYPE';

const ServiceProfileState = props => {
    const initialState = {
        serviceProfiles: [],
        serviceProfile: null,
        cliente: null,
        formulario: false,
        errorformulario: false,
        mensaje: null
    }

    const [state, dispatch] = useReducer(serviceProfileReducer, initialState);
    const obtenerServiceProfiles = async () => {
        try {
            // siempre deberia venir un cliente
            let resultado;
            resultado = await clienteAxios.get(`/serviceProfiles`);

            dispatch({
                type: OBTENER_SERVICE_PROFILES,
                payload: resultado.data ? resultado.data.result : resultado
            });
            return resultado.data ? resultado.data.result : resultado
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return (error)
        }
    }
    const obtenerServiceProfile = async (serviceProfileId) => {
        try {
            let resultado;
            resultado = await clienteAxios.get(`/serviceProfiles?id=${serviceProfileId}`);
            dispatch({
                type: OBTENER_SERVICE_PROFILE,
                payload: resultado.data.error ? {"error":resultado.data.error} : resultado.data.serviceProfile
            });
            return resultado.data.error ? {"error":resultado.data.error} : resultado.data.serviceProfile
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return (error)
        }
    }
    const actualizarServiceProfile = async(serviceProfile) => {
        try {
            const resultado = await  clienteAxios.put(`/serviceProfiles/${serviceProfile.id}`, serviceProfile );
            // Actualizo el disp en el state
            /*dispatch({
                type: ACTUALIZAR_DEVICE_PROFILE,
                payload: resultado.data.deviceProfile
            }) */
            const alerta = {
                msg: "Service Profile editado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
             return resultado.status
        } catch (error) {
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    const eliminarServiceProfile = async(serviceProfileId) => {
        try {
            const resultado = await clienteAxios.delete(`/serviceProfiles/${serviceProfileId}`);
            const alerta = {
                msg: "Service Profile eliminado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
             return resultado.status
        } catch (error) {
            const alerta = {
                msg: 'Error al eliminar serviceProfile',
                categoria: 'error'
            }
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
        }
    }
    const agregarServiceProfile = async(serviceProfile) => {
        try {
            const resultado = await clienteAxios.post('/serviceProfiles',serviceProfile);
  
            const alerta = {
                msg: "Service Profile creado con exito",
                categoria: MENSAJE_ALERTA_TYPE.Exito
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })

            return resultado.status
        } catch (error) {

            const alerta = {
                msg: 'No es posible agregar el serviceProfile.',
                categoria: MENSAJE_ALERTA_TYPE.Error
            }
            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    // muestra un error de validacion
    const errorMarca = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: MARCA_ERROR,
            payload: alerta
        })
    }
    const OkMarca = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: MARCA_OK,
            payload: alerta
        })
    }
    const clearErrorMarca = () => {
        dispatch({
            type: MARCA_ERROR,
            payload: null,
        });
    };

    const clearOkMarca = () => {
        dispatch({
            type: MARCA_OK,
            payload: null,
        });
    };


    return (
        <ServiceProfileContext.Provider
            value={{
                serviceProfiles: state.serviceProfiles,
                serviceProfile:state.serviceProfile,
                cliente: state.cliente,
                formulario: state.formulario,
                errorformulario: state.errorformulario,
                mensaje: state.mensaje,
                obtenerServiceProfiles,
                obtenerServiceProfile,
                actualizarServiceProfile,
                eliminarServiceProfile,
                agregarServiceProfile,
                clearErrorMarca,
                clearOkMarca,
                errorMarca,
                OkMarca,
            }}
        >{props.children}

        </ServiceProfileContext.Provider>
    )
}
export default ServiceProfileState;
